import React, { forwardRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { MAP_STYLES } from "../../../common/constants/MapOptions";
import { updateMapStyle } from '../../../slices/layersSlice';
import { reset } from "../../../slices/optionsSlice";
import "./LayersBox.css";
import useOutsideClickHandler from "../../../common/utils/useOutsideClickHandler";
import RoundChecked from "../../../assets/images/svgs/RoundChecked.svg?react"
import RoundUnChecked from "../../../assets/images/svgs/RoundUnChecked.svg?react"
import LayersIconGreen from "../../../assets/images/svgs/LayersIconGreen.svg?react"

const LayersBox = forwardRef(function LayersBoxComponent({ props }, ref) {

  const dispatch = useDispatch();

  const layers = useSelector(state => state.layers);
  const isSidebarOpen = useSelector(state => state.map.isSidebarOpen);

  const handleReset = () => dispatch(reset());
  useOutsideClickHandler(ref, handleReset);

  const RenderVisualisationMapStyleOption = (item, index) => {
    return (
      <div className="popupBoxDiv" key={index}>
        <button className="popupBoxCheckBoxBtn" style={{ paddingLeft: "4px" }} onClick={() => dispatch(updateMapStyle(item))}>
        {item.name === layers.mapStyle.name ? <RoundChecked/> : <RoundUnChecked/>}
        </button>
        <div className={item.name === layers.mapStyle.name ? "popupBoxText active" : "popupBoxText"}>{item.name}</div>
      </div>
    )
  };

  return (
    <>
      <div ref={ref} className={isSidebarOpen ? "popupBox layersBox isSideBarRightOpen" : "popupBox layersBox "}>
        <div className="popupBoxDiv" style={{ marginBottom: "6px" }}>
          <LayersIconGreen />
          <div className="popupBoxText popupBoxHeaderText">Layers</div>
        </div>

        <div className="visualisationBoxHead">Map Style</div>
        {MAP_STYLES.map(RenderVisualisationMapStyleOption)}

      </div>
    </>
  );
});

export default LayersBox;
